import { render, staticRenderFns } from "./settlementDetails.vue?vue&type=template&id=31712ab5&"
import script from "./settlementDetails.vue?vue&type=script&lang=js&"
export * from "./settlementDetails.vue?vue&type=script&lang=js&"
import style0 from "./settlementDetails.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports